<template>
  <div></div>
</template>

<script setup>
import { onMounted } from 'vue'
import { bus } from '@core/events/eventSystem'
import constants from '@core/utils/constants'
import { getStore } from '@core/store'

function scheduleRewardOnboarding() {
  setTimeout(() => {
    launchRewardOnboarding()
  }, 10_000)
}

function launchRewardOnboarding() {
  const store = getStore('rewards')
  store.state.previousUserLevelData = {
    level: 1,
    levelName: 'Nouveau client',
    activeMilestone: 'firstOrder',
    xpPercent: 0,
    totalXp: 0,
    isElligible: true,
  }
  store.state.userLevelData = {
    level: 2,
    levelName: 'Découvreur',
    activeMilestone: 'firstOfLevel2',
    xpPercent: 0,
    totalXp: 0,
    isElligible: true,
  }
  store.state.lastLevelAnimation = {
    from: 0,
    to: 0,
  }
  bus.emit(constants.EVENTS.NAVIGATION.BOTTOM_NAV_REQUIRED, {
    id: 'rewards',
  })
}

function setInitialState() {
  const store = getStore('rewards')
  if (store.state.userLevelData) return
  store.state.userLevelData = {
    level: 1,
    levelName: 'Nouveau client',
    activeMilestone: 'firstOrder',
    xpPercent: 0,
    totalXp: 0,
    isElligible: false,
  }
}

function subscribeToRapidooConnect() {
  const store = getStore('rewards')
  store.state.userLevelData = {
    level: 1,
    levelName: 'Nouveau client',
    activeMilestone: 'firstOrder',
    xpPercent: 0,
    totalXp: 0,
    isElligible: true,
  }
}

function relaunchUnfinishedOnboard() {
  const store = getStore('rewards')
  const currentLevel = store.state.userLevelData
  const previousUserLevelData = store.state.previousUserLevelData
  const lastLevelAnimation = store.state.lastLevelAnimation

  if (!currentLevel || !previousUserLevelData) return
  if (
    lastLevelAnimation &&
    lastLevelAnimation?.from == previousUserLevelData.level &&
    lastLevelAnimation &&
    lastLevelAnimation?.to == currentLevel.level
  )
    return

  bus.emit(constants.EVENTS.NAVIGATION.BOTTOM_NAV_REQUIRED, {
    id: 'rewards',
  })
}

onMounted(() => {
  window.scheduleRewardOnboarding = scheduleRewardOnboarding
  window.subscribeToRapidooConnect = subscribeToRapidooConnect
  // setTimeout(relaunchUnfinishedOnboard, 5000)
  setInitialState()
})
</script>
